import { faBan, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "../../../constants/i18n";
import { E_KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE } from "../../../constants/enums/khattabat-one-o-two-message-hide-type.enum";
import { TKhattabatOneOTwoMessageDisplayedHistoryEvent } from "../../../types/khattabat-one-o-two-message.type";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import Et3Margin from "../../et3-ui/ET3Margin";
import { getKhattabatOneOTwoHistoryEventTypeI18nKey } from "../../../helpers/et3-khattabat-one-o-two-history-helper";

export const KhattabatOneOTwoHistoryColumn = withLiteObserverAndTheme<{
  columnTitle: string;
  participantID: number;
  historyEvents: TKhattabatOneOTwoMessageDisplayedHistoryEvent[];
  rowColor: string;
  withColumnHeader: boolean;
}>((props) => {
  const {
    columnTitle,
    participantID,
    historyEvents,
    rowColor,
    withColumnHeader,
    theme
  } = props;
  const { colors, unitX } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={450}
      height={0}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {withColumnHeader ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={450}
          height={50}
          color={colors.all.paleBluishGray}
          style={{}}
          onClick={() => {}}
        >
          <Et3Margin top={0} bottom={0} left={20} right={0} />
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={20}
            isSpan={false}
            text={`${columnTitle} (${participantID})`}
            color={colors.all.black}
            style={{}}
          />
        </ET3Div>
      ) : null}

      {historyEvents.map((event, eventIndex) => (
        <ET3Div
          key={`${event.occurredOn}_${event.eventType}_${eventIndex}`}
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={450}
          height={70}
          color={rowColor}
          style={{}}
          onClick={() => {}}
        >
          <Et3Margin top={0} bottom={0} left={20} right={0} />
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            fDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            withShadow={false}
            width={60}
            height={0}
            color={colors.all.transparent}
            style={{}}
            onClick={() => {}}
          >
            {event.isHideEvent ? (
              <FontAwesomeIcon
                icon={
                  event.label ===
                  E_KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE.FOR_EVERYONE
                    ? faBan
                    : faEyeSlash
                }
                color={colors.all.davysGrey}
                size="lg"
              />
            ) : (
              <Et3Text
                fontFamily={"MEDIUM"}
                fontSize={22}
                isSpan={false}
                text={event.label}
                color={colors.all.black}
                style={{}}
              />
            )}
          </ET3Div>
          <ET3Div
            isScrollable={false}
            isExtendable={true}
            fDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            withShadow={false}
            width={0}
            height={0}
            color={colors.all.transparent}
            style={{ width: "auto", flexGrow: 1 }}
            onClick={() => {}}
          >
            <Et3Text
              fontFamily={"BOLD"}
              fontSize={18}
              isSpan={false}
              text={
                event.isHideEvent
                  ? i18n.get("KHATTABAT_ONE_O_TWO_HISTORY_EVENT_HIDDEN")
                  : i18n.get(
                      getKhattabatOneOTwoHistoryEventTypeI18nKey(
                        event.eventType
                      )
                    )
              }
              color={colors.all.black}
              style={{}}
            />
          </ET3Div>
          {event.isCurrent ? (
            <ET3Div
              isScrollable={false}
              isExtendable={false}
              fDirection="row"
              justifyContent="center"
              alignItems="center"
              withShadow={false}
              width={90}
              height={24}
              color={colors.all.bondiBlue}
              style={{
                boxSizing: "border-box",
                borderRadius: 12 * unitX,
                flexShrink: 0
              }}
              onClick={() => {}}
            >
              <Et3Text
                fontFamily={"MEDIUM"}
                fontSize={12}
                isSpan={true}
                text={i18n.get("KHATTABAT_ONE_O_TWO_HISTORY_EVENT_CURRENT")}
                color={colors.all.white}
                style={{}}
              />
            </ET3Div>
          ) : null}
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            fDirection="row"
            justifyContent="flex-end"
            alignItems="center"
            withShadow={false}
            width={150}
            height={0}
            color={colors.all.transparent}
            style={{}}
            onClick={() => {}}
          >
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={16}
              isSpan={false}
              text={event.occurredOn}
              color={colors.all.davysGrey}
              style={{}}
            />
          </ET3Div>
          <Et3Margin top={0} bottom={0} left={0} right={20} />
        </ET3Div>
      ))}
    </ET3Div>
  );
});
